<template>
    <v-col cols="12" md="4" ma-1>
        <v-card>
            <v-card-title class="title font-weight-black">
                My Hotels
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-layout wrap>
                        <v-col cols="12" md="6" v-for="hotel in hotels">
                           <v-btn block :href="hotelDashboard(hotel)">{{ hotel.hotel_name }}</v-btn>
                        </v-col>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
    /**
     * Display helpful information
     */
    export default {
        props:[],

        data: function() {
            return {
                hotels: []
            }
        },

        /**
         * Perform the following actions on startup
         */
        methods: {
            getHotels:function(){
                // Extract the hotel ID from the result set passed into this panel from the dashboard
                axios.get('/api/user/my-hotels')
                .then(function(response){
                   this.hotels = response.data;
                }.bind(this));
            },


            hotelDashboard: function(hotel){
                return "/hotel/" + hotel.hotel_key + "/dashboard";
            }
        },


        mounted: function() {
            this.getHotels();
        },

        computed: {}
    }
</script>
